import * as helper from './../../../Assets/Js/helper';
import * as Events from './Events';

export default class SignupHandler {
	private readonly paytourInitObject: { minAmount: number; hideClose: boolean; disableJump: boolean; texts: { BonusTextCustom: string; BonusTextCustomSecondary: string; TicketHeadline: string }; host: number; targetUrl: string; signupName: string; option: string };
	private opened: number;
	private readonly maxOpens: number;
	private readonly extender: string;
	private readonly ab1: number;
	private readonly ab4: number;
	private teaserOverlay: HTMLDivElement;
	private teaserClose: HTMLAnchorElement;
	private teaserButton: HTMLAnchorElement;

	constructor() {
		this.opened = 0;
		this.maxOpens = parseInt(helper.getData(helper.$('#chatroom'), 'ab2'));
		this.extender = helper.getData(helper.$('#chatroom'), 'extender')
		this.ab1 = parseInt(helper.getData(helper.$('#chatroom'), 'ab1'));
		this.ab4 = parseInt(helper.getData(helper.$('#chatroom'), 'ab4'));
		this.teaserOverlay = document.querySelector('#teaser_overlay');
		this.teaserClose = this.teaserOverlay.querySelector('.close');
		this.teaserButton = this.teaserOverlay.querySelector('.btn');

		this.paytourInitObject = {
			'signupName': '',
			'targetUrl': '',
			'host': 0,
			'hideClose': false,
			'minAmount': 2500, // cents
			'disableJump': true,
			'option': '2XITGA',
			'texts': {
				BonusTextCustom: '& erhalte 100% Bonus geschenkt',
				BonusTextCustomSecondary: 'Erhalte 100% Bonus geschenkt!',
				TicketHeadline: 'Sooo Geil!'
			}
		};

		helper.addClickListener(this.teaserClose, (e: MouseEvent) => {
			e.preventDefault();
			helper.hide(this.teaserOverlay);
		});

		helper.addClickListener(this.teaserButton, (e:MouseEvent) => {
			e.preventDefault();
			this.finalAction(this.paytourInitObject.host);
		})

		helper.addEventListener(window, Events.USERNAME_SELECTED, (data) => {
			this.paytourInitObject.signupName = data.detail.name;
		});

		helper.addEventListener(window, Events.CREATE_SIGNUP, (data) => {
			if (data.detail?.lock) {
				this.paytourInitObject.hideClose = true;
			}

			this._handleSignup(data.detail?.id);
		});
	}

	_handleSignup(id) {
		this.paytourInitObject.host = parseInt(id);

		this.opened++;
		if (this.opened >= this.maxOpens) {
			this.paytourInitObject.hideClose = true;
			helper.hide(this.teaserClose);
		}

		if (this.ab4 === 0) {
			this.finalAction(id);
		} else {
			helper.show(this.teaserOverlay);
		}
	}

	private finalAction(id) {
		if (this.ab1 === 1) {
			window.location.href = `https://www.visit-x.net?bonus=2XITGA&option=2XITGA&s=${id}&${this.extender}`;
			return;
		}

		// @ts-ignore
		window.paytourHelper.openPaytour(this.paytourInitObject);
	}
}
